import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { useAuth } from './context/AuthContext'
import { Dashboard } from './pages/Dashboard'
import { Kitchen } from './pages/Kitchen'
import { Reception } from './pages/Reception'
import { Login } from './pages/Login'
import { Products } from './pages/Products'
import { Orders } from './pages/Orders'
import { ClosedTableOrders } from './pages/ClosedTableOrders'
import { Cashier } from './pages/Cashier'
import { CashOperations } from './pages/CashOperations'
import { Staff } from './pages/Staff'
import { Settings } from './pages/Settings'
import { Tables } from './pages/Tables'
import { GuestTableExperience } from './pages/GuestTableExperience'
import { Reports } from './pages/Reports'
import { Stock } from './pages/Stock'
import { Fiscal } from './pages/Fiscal'
import { Customers } from './pages/Customers'
import { Loyalty } from './pages/Loyalty'
import { Waiter } from './pages/Waiter'
import { QuickSales } from './pages/QuickSales'
import { CommandsCenter } from './pages/CommandsCenter'
import { Cancellations } from './pages/Cancellations'
import { TableAudit } from './pages/TableAudit'
import { PublicMenu } from './pages/PublicMenu'
import { ManualExit } from './pages/ManualExit'
import { Observations } from './pages/Observations'
import { DrinkVouchers } from './pages/DrinkVouchers'
import { Fiado } from './pages/Fiado'
import { AccountsPayable } from './pages/AccountsPayable'

function ProtectedLayout() {
  const { user, profile, loading } = useAuth()
  const location = useLocation()

  if (loading) return <div className="splash"><span className="brand-mark">G</span><p>Verificando acesso…</p></div>
  if (!user || !profile?.active) return <Navigate to="/acesso" replace state={{ from: location }} />
  return <AppShell />
}

function RoleRoute({ roles, children }: { roles:string[]; children:React.ReactNode }) {
  const { profile } = useAuth()
  if (!profile || !roles.includes(profile.role)) return <Navigate to="/painel" replace />
  return children
}

function HomeRoute(){
  const {profile}=useAuth()
  if(profile?.role==='waiter') return <Navigate to="/garcom" replace/>
  return <Dashboard/>
}

export default function App() {
  return <Routes>
    <Route index element={<PublicMenu/>}/>
    <Route path="/login" element={<PublicMenu/>}/>
    <Route path="/acesso" element={<Login/>}/>
    <Route path="mesa/:token" element={<GuestTableExperience/>}/>
    <Route element={<ProtectedLayout/>}>
      <Route path="painel" element={<HomeRoute/>}/>
      <Route path="garcom" element={<RoleRoute roles={['super_admin','admin','manager','waiter']}><Waiter/></RoleRoute>}/>
      <Route path="mesas" element={<RoleRoute roles={['super_admin','admin','manager','waiter']}><Tables/></RoleRoute>}/>
      <Route path="produtos" element={<RoleRoute roles={['super_admin','admin','manager']}><Products/></RoleRoute>}/>
      <Route path="estoque" element={<RoleRoute roles={['super_admin','admin','manager','stock']}><Stock/></RoleRoute>}/>
      <Route path="fiscal" element={<RoleRoute roles={['super_admin','admin','manager','finance']}><Fiscal/></RoleRoute>}/>
      <Route path="clientes" element={<RoleRoute roles={['super_admin','admin','manager','cashier','waiter']}><Customers/></RoleRoute>}/>
      <Route path="fidelidade" element={<RoleRoute roles={['super_admin','admin','manager','cashier','waiter']}><Loyalty/></RoleRoute>}/>
      <Route path="comandas" element={<RoleRoute roles={['super_admin','admin','manager','cashier','waiter']}><CommandsCenter/></RoleRoute>}/>
      <Route path="pedidos-fechados" element={<RoleRoute roles={['super_admin','admin','manager','cashier']}><ClosedTableOrders/></RoleRoute>}/>
      <Route path="pedidos" element={<RoleRoute roles={['super_admin','admin','manager','cashier','waiter']}><Orders/></RoleRoute>}/>
      <Route path="cancelamentos" element={<RoleRoute roles={['super_admin','admin','manager']}><Cancellations/></RoleRoute>}/>
      <Route path="auditoria-mesas" element={<RoleRoute roles={['super_admin','admin','manager']}><TableAudit/></RoleRoute>}/>
      <Route path="vendas-rapidas" element={<RoleRoute roles={['super_admin','admin','manager','cashier','waiter']}><QuickSales/></RoleRoute>}/>
      <Route path="caixa" element={<RoleRoute roles={['super_admin','admin','manager','cashier','finance']}><Cashier/></RoleRoute>}/>
      <Route path="contas-a-pagar" element={<RoleRoute roles={['super_admin','admin','manager','cashier','finance']}><AccountsPayable/></RoleRoute>}/>
      <Route path="fiado" element={<RoleRoute roles={['super_admin','admin','manager','cashier','finance']}><Fiado/></RoleRoute>}/>
      <Route path="caixa-operacoes" element={<RoleRoute roles={['super_admin','admin','manager','cashier']}><CashOperations/></RoleRoute>}/>
      <Route path="saida" element={<RoleRoute roles={['super_admin','admin','manager','cashier','waiter']}><ManualExit/></RoleRoute>}/>
      <Route path="observacoes" element={<RoleRoute roles={['super_admin','admin','manager','cashier','waiter','kitchen','bar']}><Observations/></RoleRoute>}/>
      <Route path="fichas" element={<RoleRoute roles={['super_admin','admin','manager','cashier','waiter']}><DrinkVouchers/></RoleRoute>}/>
      <Route path="recepcao" element={<RoleRoute roles={['super_admin','admin','manager','cashier']}><Reception/></RoleRoute>}/>
      <Route path="relatorios" element={<RoleRoute roles={['super_admin','admin','manager','finance']}><Reports/></RoleRoute>}/>
      <Route path="funcionarios" element={<RoleRoute roles={['super_admin','admin','manager']}><Staff/></RoleRoute>}/>
      <Route path="cozinha" element={<RoleRoute roles={['super_admin','admin','manager','kitchen','bar']}><Kitchen/></RoleRoute>}/>
      <Route path="configuracoes" element={<RoleRoute roles={['super_admin','admin','manager']}><Settings/></RoleRoute>}/>
    </Route>
    <Route path="*" element={<Navigate to="/" replace/>}/>
  </Routes>
}